const drawerSectionId = document.querySelector('cart-drawer').dataset.id;
class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      window.freeProductSwatch();
      // if (
      //   sectionElement.querySelector('#CartDrawer') &&
      //   sectionElement.querySelectorAll('#CartDrawer [data-free-product="true"]').length > 0
      // ) {
      //   let freeProductId = sectionElement.querySelector('[data-free-product-id]').dataset.freeProductId;
      //   let productFreeId = sectionElement.querySelector('[data-product-free-id]').dataset.productFreeId;

      //   if (freeProductId && productFreeId) {
      //     window.freeProductAdd(freeProductId, productFreeId);
      //   }
      // }
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: drawerSectionId,
        selector: 'cart-drawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: drawerSectionId,
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

function freeGiftProductOptionClick() {
  this.closest('.free-shipping-threshold-disabled').classList.add('disabled');
  this.removeEventListener('click', freeGiftProductOptionClick);
  const productId = this.dataset.productId;
  const variantId = this.dataset.variantId;
  const productTitle = this.dataset.productTitle;
  const giftOptions = document.querySelectorAll('.free-gift-product-option');

  // Update UI
  giftOptions.forEach((opt) => {
    opt.classList.remove('active', 'tw-border-blue-500');
    opt.classList.add('tw-border-gray-200');
  });
  this.classList.add('active', 'tw-border-blue-500');
  this.classList.remove('tw-border-gray-200');

  // Update title
  const giftTitle = document.querySelector('.free-gift-title');
  if (giftTitle) {
    giftTitle.textContent = productTitle;
  }

  // Update free product in cart
  const freeProductMessage = document.querySelector('[data-free-product="true"]');

  if (freeProductMessage) {
    freeProductMessage.dataset.freeProductId = productId;
    freeProductMessage.dataset.productFreeId = productId;
    window.freeProductSwap(productId, variantId, this);
  }
  window.setBundleItemsOnLoad();
  window.initStickyBagScrollbar();
}

window.freeProductSwap = function (productId, variantId, clickedElement) {
  // First, remove any existing free product
  const cartItemsWrapper = clickedElement.closest('cart-items');
  const cartItems = clickedElement.closest('.cart-items-wrapper').querySelectorAll('.cart-item');
  let hasFreeProduct = false;
  let freeProductLineItem = null;

  cartItems.forEach((item, index) => {
    if (item.classList.contains('has-free-item')) {
      hasFreeProduct = true;
      freeProductLineItem = index + 1; // Line items are 1-indexed
    }
  });

  // Function to add the new free product
  const addNewFreeProduct = () => {
    const formData = {
      items: [
        {
          id: variantId,
          quantity: 1,
          properties: {
            _free_gift: 'Free Gift',
          },
        },
      ],
    };

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    })
      .then((response) => response.json())
      .then((data) => {
        // Refresh cart drawer
        let sections = '';
        let url = `${window.Shopify.routes.root}?section_id=${drawerSectionId}`;
        if (cartItemsWrapper) {
          sections = [...cartItemsWrapper.closest('#MainContent').querySelectorAll('.shopify-section')].reduce(
            (acc, section) => {
              return `${acc}${section.id.replace('shopify-section-', '')},`;
            },
            ''
          );
          url = `${window.Shopify.routes.root}?sections=${sections}`;
        }
        fetch(url)
          .then((response) => response.text())
          .then((html) => {
            if (cartItemsWrapper) {
              const parsedState = JSON.parse(html);
              Object.keys(parsedState).forEach((key) => {
                const matchingElement = document.querySelector(`[id*="${key}"]`);
                if (matchingElement) {
                  const newElement = document.createRange().createContextualFragment(parsedState[key]);
                  matchingElement.replaceWith(newElement);
                }
              });
              window.freeProductSwatch();
              // Re-initialize event listeners
              const giftOptions = document.querySelectorAll('.free-gift-product-option');
              giftOptions.forEach((option) => {
                option.addEventListener('click', freeGiftProductOptionClick);
              });
            } else {
              const parser = new DOMParser();
              const doc = parser.parseFromString(html, 'text/html');
              var cartCountEl = doc.querySelector('.cart-count.drawer__title-count');
              var cartCount = cartCountEl ? parseInt(cartCountEl.textContent.match(/\d+/)[0]) : 0;
              const cartBubble = document.querySelector('.cart-count-bubble');
              if (cartBubble) {
                cartBubble.classList.remove('tw-hidden');
                cartBubble.querySelector('span').textContent = cartCount;
              }
              const cartDrawer = document.querySelector('cart-drawer');
              const newCartDrawer = doc.querySelector('cart-drawer');

              if (cartDrawer && newCartDrawer) {
                cartDrawer.innerHTML = newCartDrawer.innerHTML;
                window.freeProductSwatch();

                // Re-initialize event listeners
                const giftOptions = document.querySelectorAll('.free-gift-product-option');
                giftOptions.forEach((option) => {
                  option.addEventListener('click', freeGiftProductOptionClick);
                });
              }
            }
          })
          .catch((error) => console.error('Error refreshing cart drawer:', error));
      })
      .catch((error) => console.error('Error adding free product:', error));
  };

  if (hasFreeProduct && freeProductLineItem) {
    fetch(`${window.Shopify.routes.root}cart/change.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        line: freeProductLineItem,
        quantity: 0,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        // Now add the new free product
        addNewFreeProduct();
        window.setBundleItemsOnLoad();
        window.initStickyBagScrollbar();
      })
      .catch((error) => console.error('Error removing existing free product:', error));
  } else {
    // No existing free product, just add the new one
    addNewFreeProduct();
    window.setBundleItemsOnLoad();
    window.initStickyBagScrollbar();
  }
};
